/**
 * Region functions are used for reaching the endpoints for region.
 * @module Region
 * @since 0.0.8
 */
import GlobalFunctions from '../global'

module.exports = {
	/**
	 * Call to unoapp API that returns an array of regions under the specified parent id and business.
	 * @function
	 * @param {integer} businessId - The id of the business.
	 * @param {integer} parentId - The parent id that we are retrieving results for.
	 * @returns {object} A promise that will return either a success object or an error object.
	 * @version 0.0.8
	 */
	getRegions (businessId, parentId) {
		let httpParams = {
			business_id: businessId
		}

		if (parentId) {
			httpParams.parent_id = parentId
		}

		return new Promise((resolve, reject) => {
			GlobalFunctions.$ajax({
				method: 'POST',
				dataType: 'json',
				url: '/region/list',
				data: httpParams,
				success (response) {
					resolve(response)
				},
				error (e) {
					let _this = this
					let _wrapper = GlobalFunctions.refreshWrapper((e, status) => {
						if (status === 'error') {
							reject(e)
						} else {
							GlobalFunctions.$ajax(_this)
						}
					})
					_wrapper(e)
				}
			})
		})
	},
	/**
	 * Call to unoapp API that creates a new region.
	 * @function
	 * @param {integer} businessId - The id of the business.
	 * @param {string} regionName - The name of the region.
	 * @param {integer} parentId - If this region is being created as a child then this will be the parent id of the new region.
	 * @returns {object} A promise that will return either a success object or an error object.
	 * @version 0.0.8
	 */
	createRegion (businessId, regionName, parentId) {
		let httpParams = {
			business_id: businessId,
			name: regionName
		}

		if (parentId) {
			httpParams.parent_id = parentId
		}

		return new Promise((resolve, reject) => {
			GlobalFunctions.$ajax({
				method: 'PUT',
				dataType: 'json',
				url: '/region',
				data: httpParams,
				success (response) {
					resolve(response)
				},
				error (e) {
					let _this = this
					let _wrapper = GlobalFunctions.refreshWrapper((e, status) => {
						if (status === 'error') {
							reject(e)
						} else {
							GlobalFunctions.$ajax(_this)
						}
					})
					_wrapper(e)
				}
			})
		})
	},
	/**
	 * Call to unoapp API that returns an array of locations belonging to the specified region.
	 * @function
	 * @param {integer} businessId - The id of the business.
	 * @param {integer} regionId - The region id that we are retrieving results for.
	 * @returns {object} A promise that will return either a success object or an error object.
	 * @version 0.0.8
	 */
	getRegionLocations (businessId, regionId) {
		let httpParams = {
			business_id: businessId
		}

		return new Promise((resolve, reject) => {
			GlobalFunctions.$ajax({
				method: 'POST',
				dataType: 'json',
				url: '/region/' + regionId + '/locations',
				data: httpParams,
				success (response) {
					resolve(response)
				},
				error (e) {
					let _this = this
					let _wrapper = GlobalFunctions.refreshWrapper((e, status) => {
						if (status === 'error') {
							reject(e)
						} else {
							GlobalFunctions.$ajax(_this)
						}
					})
					_wrapper(e)
				}
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/controllers/Region.js